import React from 'react';
import Hero from '../components/Hero';
import PopularDestinations from '../components/PopularDestinations';
import Services from '../components/Services';
import FeaturedPackages from '../components/FeaturedPackages';
import Testimonials from '../components/Testimonials';
import ContactInfo from '../components/ContactInfo';
import HomeContactForm from '../components/HomeContactForm';
import TravelTips from '../components/TravelTips';
import WhyChooseUs from '../components/WhyChooseUs';
import TravelSeasons from '../components/TravelSeasons';
const Home = () => {
  return <div data-id="element-504">
      <Hero data-id="element-505" />
      <WhyChooseUs data-id="element-506" />
      <PopularDestinations data-id="element-507" />
      <Services data-id="element-508" />
      <FeaturedPackages data-id="element-509" />
      <TravelSeasons data-id="element-510" />
      <TravelTips data-id="element-511" />
      <Testimonials data-id="element-512" />
      <HomeContactForm data-id="element-513" />
      <ContactInfo data-id="element-514" />
    </div>;
};
export default Home;